import cx from 'classnames';
import type { ReactNode } from 'react';
import type { ButtonContentProps } from './ButtonContent';
import type { ButtonType, ButtonVariant } from './baseTypes';
import styles from './styles.module.css';

/**
 * Add the proper classes to the final Button element
 */
export const getClassNames = (
  children: ReactNode,
  withIcon: boolean,
  iconPosition: ButtonContentProps['iconPosition'],
  large: undefined | boolean,
  xLarge: undefined | boolean,
  stretch: undefined | boolean,
  type: ButtonType = 'secondary',
  disabled?: boolean,
  className?: string,
  variant?: ButtonVariant,
): string =>
  cx(
    styles.Button,
    {
      // Variants
      [styles.Primary]: type && type === 'primary',
      [styles.Secondary]: type === 'secondary',
      [styles.White]: type === 'white',
      [styles.Accent]: type && type === 'accent',
      [styles.Subtle]: type && type === 'subtle',
      [styles.SubtleDark]: type && type === 'subtle-dark',
      [styles.GhostPrimary]: variant === 'ghost' ? type === 'primary' : false,
      [styles.GhostSecondary]: variant === 'ghost' ? type === 'secondary' : false,
      [styles.Facebook]: type && type === 'facebook',
      // With icon
      [styles.OnlyIcon]: withIcon && !children,
      [styles.IconRight]: iconPosition && withIcon && children && iconPosition === 'right',
      // Size effects
      [styles.Large]: large,
      [styles.XLarge]: xLarge,
      [styles.Stretch]: children && stretch,
      // Disabled
      [styles.Disabled]: disabled,
    },
    className,
  );
